<div class="device-dialog">
    <div class="mat-h1">
       Remove issued device
    </div>
    <mat-dialog-content class="content" >
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Enter your notes here *</mat-label>
            <input matInput #input placeholder="" [(ngModel)]="notes"  maxlength="200">
            <mat-hint align="end">{{input.value.length}}/200</mat-hint>
          </mat-form-field>
  </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="onCancel()" mat-dialog-close>CANCEL</button>
        <button mat-button color="primary"   (click)="removeDevice()" [disabled]="notes == undefined || notes == '' || notes == null" *ngIf="role == 'Admin' || role == 'Front office staff' ||  role == 'Healthcare provider'">SAVE</button>
     </mat-dialog-actions>
</div>